import { logEvent as firebaseLogEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

const log = (eventName, params = {}) => {
  if (!analytics) return;
  try {
    firebaseLogEvent(analytics, eventName, params);
  } catch {
    // analytics should never break the app
  }
};

export const trackPageView = (page_path, page_title) =>
  log('page_view', { page_path, page_title });

export const trackLogin = (method = 'phone') =>
  log('login', { method });

export const trackAskQuestion = () =>
  log('ask_question');

export const trackResumePdfDownload = () =>
  log('resume_pdf_download');

export const trackAssessmentCompleted = () =>
  log('assessment_completed');
